import React from 'react'
import { observer } from 'mobx-react-lite'
import { CustomTableStore, useCustomTableStore } from './CustomTableStore'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Paper from '@mui/material/Paper'
import useCustomTableRenderLog from './hooks/useCustomTableRenderLog'
import useStore from 'reusable/mobx-store-utils'
import Box from '@mui/system/Box'

interface CustomTableContainerProps {
   children: React.ReactElement
}
export const CustomTableContainer = observer(function CustomTableContainer
   <RowData extends AnyObject, RowStore>(props: CustomTableContainerProps) {
   useCustomTableRenderLog('CustomTableContainer')
   const customTableStore = useCustomTableStore<CustomTableStore<RowData, RowStore>>()
   const localStore = useStore(() => ({
      get containerStyle(): React.CSSProperties {
         return { minHeight: customTableStore.minHeight, maxHeight: customTableStore.divMaxHeight }
      },
   }))

   const hasContainer =
      customTableStore.fullscreen ||
      customTableStore.sp.hasContainer === undefined ||
      customTableStore.sp.hasContainer === true

   const component = hasContainer ? (
      <Paper
         variant={customTableStore.sp.containerPaperVariant}
         sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto' }}
         style={localStore.containerStyle}
         square={customTableStore.sp.containerPaperSquare}>
         {props.children}
      </Paper>
   ) : (
      <Box
         sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto' }}
         style={localStore.containerStyle}>
         {props.children}
      </Box>
   )

   return customTableStore.fullscreen ? (
      <Dialog open={true} fullScreen onClose={customTableStore.toggleFullscreenByUser}>
         <DialogContent>{component}</DialogContent>
      </Dialog>
   ) : (
      component
   )
}
)
